/* This file is autogenerated, see readme.md for instructions */
import ReceiveSvgIcon from '@bloomreach/banana-theme/icons/receive.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ReceiveIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ReceiveSvgIcon />
    </Icon>
  );
});

ReceiveIcon.displayName = 'ReceiveIcon';

export default ReceiveIcon;
